var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacetedRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    id: "dia-faceted-round",
    viewBox: "19 16 54 54",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    id: "bg-fill_22_",
    d: "M46 15.9c-14.8 0-26.8 12-26.8 26.8s12 26.8 26.8 26.8 26.8-12 26.8-26.8-12-26.8-26.8-26.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "shadow_22_",
    fill: "currentColor",
    fillOpacity: 0.085,
    d: "M41.2 48.3c-8.1-8.2-12.2-18.7-14-24.6-4.9 4.8-7.9 11.6-7.9 19 0 14.8 12 26.8 26.8 26.8 7.2 0 13.7-2.9 18.5-7.5-5.8-1.8-15.5-5.7-23.4-13.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "stroke_21_",
    fill: "currentColor",
    d: "M46 15.9c-14.8 0-26.8 12-26.8 26.8s12 26.8 26.8 26.8 26.8-12 26.8-26.8-12-26.8-26.8-26.8zm22.4 36.7l-8.7 3.1-.8-7.4.2-.6 5.9-4.6 3.9 8.4c-.2.3-.3.7-.5 1.1zM54.8 65.5l-8.4-3.9 4.6-5.8.6-.2 7.4.9-3.1 8.5c-.3.2-.7.3-1.1.5zM36.1 65L33 56.3l7.4-.9.6.2 4.6 5.8-8.4 3.9c-.4 0-.7-.1-1.1-.3zM23.2 51.5l3.9-8.4 5.8 4.6.2.6-.8 7.4-8.7-3.1c-.1-.4-.3-.8-.4-1.1zm.4-18.8l8.7-3.1.8 7.4-.2.6-5.8 4.6-3.9-8.4c.1-.4.3-.7.4-1.1zm13.6-12.9l8.4 3.9-4.6 5.8-.6.2-7.4-.8 3.2-8.7c.3-.1.6-.3 1-.4zm18.7.4l3.2 8.7-7.4.9-.6-.2-4.6-5.8 8.4-3.9c.3 0 .7.2 1 .3zm12.9 13.6l-3.9 8.4-5.9-4.6-.1-.6.8-7.4 8.7 3.1c.2.4.3.7.4 1.1zM51 54.6h-9.8l-7-7v-9.9l7-7H51l7 7v9.9l-7 7zm1.2-24.3l7-.8-.8 7-6.2-6.2zm-6.2-.7h-4.4l4.4-5.5 4.4 5.5H46zm-12.3 6.9l-.8-7 7 .8-6.2 6.2zm-.8 6.1V47l-5.5-4.4 5.5-4.4v4.4zm7 12.4l-7 .8.8-7 6.2 6.2zm6.1.7h4.4L46 61.2l-4.4-5.5H46zm12.3-6.9l.8 7-7-.8 6.2-6.2zm.8-6.2v-4.4l5.5 4.4-5.5 4.4v-4.4zm.6-13.6l-3-8.4c5 2.4 9 6.4 11.4 11.4l-8.4-3zM46 23.3l-8.1-3.8c2.5-.9 5.2-1.4 8.1-1.4 2.8 0 5.5.5 8.1 1.4L46 23.3zM32.4 29L24 32c2.4-5 6.5-9 11.4-11.4l-3 8.4zm-5.7 13.6l-3.8 8.1c-.9-2.5-1.4-5.3-1.4-8.1s.5-5.6 1.4-8.1l3.8 8.1zm5.7 13.7l3 8.4c-5-2.4-9-6.4-11.4-11.4l8.4 3zm27.3 0l8.4-3c-2.4 5-6.5 9-11.4 11.4l3-8.4zm5.6-13.7l3.8-8.1c.9 2.5 1.4 5.3 1.4 8.1s-.5 5.6-1.4 8.1l-3.8-8.1zM46 62l8.1 3.8c-2.5.9-5.2 1.4-8.1 1.4-2.8 0-5.5-.5-8.1-1.4L46 62z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacetedRound);
export default __webpack_public_path__ + "static/media/faceted-round.2e79bada8135d6277fe8ff7c8f53118c.svg";
export { ForwardRef as ReactComponent };